import gql from 'graphql-tag';
import fetch from 'isomorphic-fetch';

import { HEADER_CONTENT_TYPE } from 'constants/http';
import { JSON as JSON_MIME } from 'constants/mimes';
import { WORK } from 'constants/useCasePlans';
import { UserPropertyEnum } from 'constants/userProperties';

import GetUserProperty from './GetUserProperty.graphql';
import UpdateUserProperty from './UpdateUserProperty.graphql';
import { UpdateWorkspaceSetting } from './UpdateWorkspaceSetting.graphql';
import { getGraphQLClient } from '../utilities/graphql';
import { WORKSPACE_PERSONA } from '../../../shared/constants/settings';
import { buildWorkspacePersonaFromUserPersona } from '../../../shared/utilities/workspaces';

export function patchUserPersonaInfoCreator(personaInfo) {
  return async (dispatch, getState) => {
    const { use_case_plan: currCasePlan } = getState().welcome;

    let body = { persona: { persona_v1: personaInfo } };
    const useCasePlan = currCasePlan || personaInfo.use_case_plan;

    if (useCasePlan === WORK) {
      body = {
        ...body,
        company_name: personaInfo.company,
        company_position: personaInfo.role,
      };
    }

    body = JSON.stringify(body);

    // update user profile with selected role
    if (personaInfo?.persona_role) {
      await updateUserProfileWithRole(personaInfo.persona_role);
    }

    const workspacePersona = buildWorkspacePersonaFromUserPersona(personaInfo);

    await patchWorkspacePersonaCreator(workspacePersona);

    return fetch('/v1/users', {
      method: 'PATCH',
      credentials: 'include',
      headers: { [HEADER_CONTENT_TYPE]: JSON_MIME },
      body,
    });
  };
}

async function updateUserProfileWithRole(role) {
  const gqlClient = getGraphQLClient();
  const { data } = await gqlClient.query({
    query: GetUserProperty,
    variables: { name: UserPropertyEnum.PROFILE },
  });

  const persona = data?.result?.value;

  if (persona) {
    const updatedPersona = { ...persona.v1, role };

    await gqlClient.mutate({
      mutation: UpdateUserProperty,
      variables: {
        name: UserPropertyEnum.PROFILE,
        value: { v1: updatedPersona },
      },
    });
  }
}

async function patchWorkspacePersonaCreator(newWorkspacePersonaTraits) {
  const gqlClient = getGraphQLClient();
  const { data } = await gqlClient.query({
    fetchPolicy: 'no-cache',
    query: gql`
      query GetWorkspaceSettings($names: [String!]) {
        settings: getWorkspaceSettings(names: $names) {
          ... on WorkspaceSettings {
            ${WORKSPACE_PERSONA}
          }
        }
      }
    `,
    variables: { names: [WORKSPACE_PERSONA] },
  });

  const existingWorkspacePersona = data.settings[WORKSPACE_PERSONA] || {};
  const workspacePersonaBody = Object.assign(
    {},
    existingWorkspacePersona.persona_v1,
    newWorkspacePersonaTraits
  );

  await gqlClient.mutate({
    mutation: UpdateWorkspaceSetting,
    variables: {
      name: WORKSPACE_PERSONA,
      value: { persona_v1: workspacePersonaBody },
    },
  });
}

export function patchUserHelpOptionsCreator() {
  return (dispatch, getState) => {
    const { helpOptions: help_options } = getState().welcome;

    return fetch('/v1/users', {
      method: 'PATCH',
      credentials: 'include',
      headers: { [HEADER_CONTENT_TYPE]: JSON_MIME },
      body: JSON.stringify({ help_options }),
    });
  };
}
